module.exports = __webpack_public_path__ + "img/咖啡.bc776309.gif";